import styled from "styled-components";
import { BASIC_DARK_GRAY } from "../../../constants/colors";
import { PageRoutes } from "../../../constants/routes";
import { useNavigation } from "../../../hooks/useNavigation";
import { Button } from "../../atoms/Button";

export const MembershipInfoSent: React.FC = () => {
  const { navigateToPage } = useNavigation();

  return (
    <Container>
      <TitleWrapper>送信完了</TitleWrapper>
      <Message>送信が完了しました。</Message>

      <ButtonWrapper>
        <Button
          btnStyle="secondary"
          text="ログインする"
          onClick={() => navigateToPage(PageRoutes.LOGIN)}
          rounded="md"
        />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  color: ${BASIC_DARK_GRAY};
  padding: 0 16px 60px;
  display: flex;
  flex-direction: column;
  text-align: left;
`;

const TitleWrapper = styled.div`
  font-size: 20px;
  font-weight: 600;
  padding: 43px 0 38px 0;
  display: flex;
  justify-content: center;
  line-height: 1em;
  font-family: "Hiragino Sans";
`;

const Message = styled.div`
  font-size: 14px;
  font-weight: 300;
  text-align: center;
  font-family: "Hiragino Sans";
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0 392px;
  button {
    height: auto;
    line-height: 1;
    font-weight: 500;
    font-family: "Hiragino Sans";
  }
`;
